// Angular
import { FormBuilder, FormGroup } from '@angular/forms';
import { Required } from "libraries/module/formbuilder/forms/utils/validators/required.validator";

export function formGroupConfig (formBuilder: FormBuilder): FormGroup {
    return formBuilder.group({
        body: [''],
        stopClause: ['']
    });
}

export function getValidators (formControlName: string) {
    if (validators.hasOwnProperty(formControlName)) {
        return validators[formControlName];
    }
}

const validators = {
    body: body()
};

function body () {
    return [new Required()];
}